import { useQuery } from '@tanstack/react-query';
import type { SearchSubscriptionResponse } from '@//app/api/protected/subscriptions/search/[id]';
import { useAuth } from '@//providers/AuthProvider';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { type FetchError, httpClientGetAuthorizedJson } from '../../httpClient';

export const SEARCH_SUBSCRIPTION_CACHE_KEY = 'api/protected/subscriptions/search:/:id';

const useSearchSubscription = (id?: string) => {
  const { initialized, decodedToken } = useAuth();
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<SearchSubscriptionResponse, FetchError>({
    queryKey: [SEARCH_SUBSCRIPTION_CACHE_KEY, decodedToken?.sub, id],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/protected/subscriptions/search/${id}`;
      return await httpClientGetAuthorizedJson<SearchSubscriptionResponse>(url);
    },
    enabled: !!id && initialized,
    retry: 2,
  });

  return query;
};

export default useSearchSubscription;
